import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IntegrationsHttpClient } from '@recruitee/integrations/http';

import { IntegrationsFeatureFlagsActions } from './feature-flags.store';

@Injectable({ providedIn: 'root' })
export class IntegrationFeatureFlagsEffects {
  private fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IntegrationsFeatureFlagsActions.fetch),
      switchMap(() =>
        this.api.loadFeatureFlags().pipe(
          map(features => IntegrationsFeatureFlagsActions.fetchSuccess({ payload: features })),
          catchError(error => of(IntegrationsFeatureFlagsActions.fetchFailed({ payload: error }))),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private api: IntegrationsHttpClient) {}
}
